<template>
  <v-app>

    <v-navigation-drawer v-model="drawer" app >
      <v-list>

        <v-list-item link v-for="item in menuItems" 
                     :key="item.link" 
                     :to="item.link" >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>BAKINITY</v-toolbar-title>
      <v-spacer></v-spacer>
      {{ time | timestampToDateTimeSec }}
    </v-app-bar>

    <v-content>
      <transition appear name="fade" mode="out-in"> 
        <router-view></router-view>
      </transition>
    </v-content>

    <v-footer app dark color="primary py-2" class="caption">
      <div>conf.bakinity.az </div>
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>

  </v-app>
</template>

<script>
  export default {

    data: () => ({
      drawer: false,
      time: "",
      menuItems: [
        { title: 'Главная', link: '/', icon: 'mdi-home' },
        { title: 'Записи', link: '/meetups', icon: 'mdi-format-list-numbered' },
        { title: 'Заказы', link: '/orders', icon: 'mdi-tea-outline' },
        { title: 'Слайдер', link: '/slides', icon: 'mdi-image-frame' },
        { title: 'Пользователь', link: '/user', icon: 'mdi-account' }
      ]
    }),
    methods: {
      getNow: function() {
        this.time = new Date().getTime();
      }
    },
    computed: {
      userIsAuthenticated(){
        this.$store.dispatch('userIsAuthenticated');
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
      }
    },
    created() {
      setInterval(this.getNow, 1000);
    },
  }
</script>


<style>

/* Анимация перехода между компонентами */

.fade-enter-active, .fade-leave-active {
  transition: all .3s ease;
  transform: translateY(0);
  opacity: 1;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(150px);
}
img {
  max-width: 100%;
}
</style>